import { map, pick } from 'lodash/fp'
import { hasFirstYearLstu } from 'quick-quote/product-investment/coverage-plan/selectors'
import VALUES from 'core/data-model/constants/values'

const mapFundAllocations = (fundAllocations) => {
  return map(pick(['code', 'englishName', 'thaiName', 'fundAllocation', 'factSheet', 'isForeign', 'isOverRisk']))(
    fundAllocations
  )
}

const mapFund = (fund) => ({
  allocations: mapFundAllocations(fund.allocations),
})

const mapLstu = (state) => {
  return hasFirstYearLstu(state)
    ? {
        lstu: {
          ...(state.investment.funds.lstu.selectedAllocationOption === VALUES.LSTU_FUND_ALLOCATION_OPTION.INDEPENDENT
            ? mapFund(state.investment.funds.lstu)
            : {}),
          selectedAllocationOption: state.investment.funds.lstu.selectedAllocationOption,
        },
      }
    : {}
}

export const mapFunds = (state) => ({
  rpp: mapFund(state.investment.funds.rpp),
  ...mapLstu(state),
})
